export function phoneWithout998(value) {
    return /^(\d{9})$/.test(value)
}